
import React, { useContext, useEffect, useState } from 'react'
import { PAGE_TITLES } from '../../../constants'
import PageTitle from '../../atoms/PageTitle'
import Layout from '../../templates/Layout'
import cs from "classnames";
import classes from "./Zoom.module.scss";

import zoomLogo from "../../../assets/images/zoom-logo.png";
import liveLogo from "../../../assets/images/live.png";
import ZoomButton from './components/ZoomButton';
import { useTranslation } from 'react-i18next';
import { AuthorizationKids } from '../../organisms/RestrictionModal/RestrictionModal';
import { StoreContext } from '../../../contexts';
import { useModal, useQuery } from '../../../hooks';
import Modal from '../../organisms/Modal';
import Player from '../../organisms/Player';
import { isMobile } from 'react-device-detect';
import Icon from '../../atoms/Icon';
import { observer } from 'mobx-react-lite';

const days = {
    0: "יום ראשון",   // Sunday
    1: "יום שני",     // Monday
    2: "יום שלישי",   // Tuesday
    3: "יום רביעי",   // Wednesday
    4: "יום חמישי",   // Thursday
    5: "יום שישי",    // Friday
    6: "שבת"          // Saturday
};

const Zoom = observer(() => {
    const { t } = useTranslation();
    const query = useQuery();
    const { authorization, zoom } = useContext(StoreContext)
    // Always show bottom section initially as now there is no requirement to show it conditionally.ś
    const [showBottom, setShowBottom] = useState(true);
    const authPopup = useModal()
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleZoomButtonClick = () => {
        if (!authorization.isAuthenticated) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('enter', '1');
            window.history.replaceState(null, '', currentUrl);
            authPopup.onOpen();
            return;
        }
        setShowBottom(true);
    };


    useEffect(() => {
        if (query.get("enter") && authorization.isAuthenticated) {
            setShowBottom(true);
        }
    }, [query]);

    useEffect(() => {
        zoom.getZoomSettings();
    }, []);

    const handleJoinZoom = () => {
        if (!authorization.isAuthenticated) {
            authPopup.onOpen();
            return;
        }

        const zoomUrl = zoom.settings?.zoom_link || "https://zoom.us";
        window.open(zoomUrl, "_blank");
    };

    const handlePDF = (url) => {
        if (!authorization.isAuthenticated) {
            authPopup.onOpen();
            return;
        }

        if (!url) return;
        window.open(url, "_blank");
    };

    const handleOpenVideo = (video) => {
        if (!authorization.isAuthenticated) {
            authPopup.onOpen();
            return;
        }

        setSelectedVideo(video);
        setIsModalOpen(true);
    };

    const isLive = zoom.settings?.zoom_live_status === "yes";

    return (
        <>
            <PageTitle value={PAGE_TITLES.ZOOM} />
            <Layout logotype="maor" page="zoom">
                <div className={cs(classes.bgZoom, "bgc-white")}>
                    <div className={cs(classes.container, "wrapper-m")}>

                        {
                            !showBottom ?
                                <div className={cs(classes.zoomContent)}>
                                    <img src={zoomLogo} alt="Zoom" className={classes.zoomImage} />

                                    {/* Pass onClick to ZoomButton here */}
                                    <ZoomButton onClick={handleZoomButtonClick} >
                                        {t('zoomPage.texts.1')}
                                    </ZoomButton>

                                    <div className='mt-03'>
                                        <h3 className={classes.zoomText}>
                                            {t('zoomPage.texts.2')}
                                            <br />
                                            {t('zoomPage.texts.3')}
                                        </h3>
                                    </div>
                                </div> : ""
                        }
                        {/* Conditionally render zoomContentBottom */}
                        {showBottom && (
                            <div className={cs(classes.zoomContentBottom)}>
                                <div className={cs(classes.zoomBottomContainer)}>
                                    <div className={cs(classes.zoomRightContainer)}>
                                        <div className={classes.logoWrapper}>
                                            <img src={zoomLogo} alt="Zoom" className={classes.zoomImage} />
                                        </div>
                                        <div className={cs(classes.zoomButton)}>
                                            {isLive && <img src={liveLogo} className={classes.liveImg} />}
                                            <ZoomButton disabled={zoom.settings?.zoom_link == 'https://mymaor-disabled.org'} onClick={handleJoinZoom}>
                                                {t('zoomPage.buttonText.4')}
                                            </ZoomButton>
                                        </div>
                                    </div>

                                    <div className={cs(classes.zoomLeftContainer)}>
                                        <h1 className={cs(classes.title)}>
                                            {t('zoomPage.texts.8')}
                                        </h1>
                                        <div className={cs(classes.zoomButtonContainer)}>
                                            <ZoomButton
                                                onClick={() => handlePDF(zoom.settings?.file1)}
                                                variant="secondary"
                                            >
                                                {t('zoomPage.buttonText.1')}
                                            </ZoomButton>

                                            <ZoomButton
                                                onClick={() => handlePDF(zoom.settings?.file2)}
                                                variant="secondary"
                                            >
                                                {t('zoomPage.buttonText.2')}
                                            </ZoomButton>

                                            <ZoomButton
                                                onClick={() => handlePDF(zoom.settings?.file3)}
                                                variant="secondary"
                                            >
                                                {t('zoomPage.buttonText.3')}
                                            </ZoomButton>
                                        </div>

                                        <h3 className={cs(classes.zoomText, classes.zoomTextBottom)}>
                                            {t('zoomPage.texts.2')}
                                            <br />
                                            {t('zoomPage.texts.3')}
                                        </h3>
                                    </div>
                                </div>

                                {zoom.settings?.links && zoom?.settings?.links?.length > 0 && (
                                    <div className='mt-13'>
                                        <p className={cs(classes.recordText)}>{t('zoomPage.texts.7')}</p>
                                        <div className={cs(classes.zoomRecordingContainer)}>
                                            {zoom.settings.links.map((link, index) => (
                                                <ZoomButton
                                                    key={index}
                                                    borderRadius="18px"
                                                    size="medium"
                                                    onClick={() => handleOpenVideo(link)} // Pass the link (video object)
                                                    variant="lightblue"
                                                >
                                                    {days[index]}
                                                </ZoomButton>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </Layout>
            <AuthorizationKids popup={authPopup} />
            <Modal
                opened={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            >
                <div
                    data-name="modal-overlay"
                    className={cs(classes.overlay)}
                    role="button"
                    onClick={(event) => {
                        if (event.target.matches(`[data-name="modal-overlay"]`))
                            authPopup.onClose();
                    }}
                >
                    <div className={classes.modalContent}>
                        <div
                            onClick={() => setIsModalOpen(false)}
                            className={classes.closeContainer}
                        >
                            <Icon size="xs" name="x" cursorPointer={true} />
                        </div>

                        {selectedVideo && (
                            <Player
                                additionalClass={isMobile ? "mobileHeight" : "desktopHeight"}
                                autoplay
                                video={selectedVideo}
                                muted={isMobile}
                            />
                        )}
                    </div>
                </div>
            </Modal>

        </>
    );
});

export default Zoom;
